import React from "react";
import {
  Checkbox,
  FormControlLabel,
  Typography,
  makeStyles,
} from "@material-ui/core";

export const FilterItems = (props: any) => {
  const classes = useStyles();
  const { title, helperText } = props;

  return (
    <div className={classes.root}>
      <FormControlLabel
        control={
          <Checkbox
            checked={props?.checked}
            value="remember"
            color="primary"
            onChange={(e: any) => props.onChange(e.target.checked)}
          />
        }
        label=""
        style={{ marginRight: 0 }}
      />
      <Typography variant="body2" component="span">
        {title}
        {helperText &&
          <Typography variant="caption" component="p" className={classes.helperText}>
            {helperText}
          </Typography>
        }
      </Typography>
    </div>
  );
};
const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8
  },
  helperText: {
    fontWeight: 'normal',
    lineBreak: 'anywhere',
    maxWidth: 240
  }
});
